export const appConfig = {
  language: "it",
  title: "Demo Assisstant",
  favicon: "/favicon-s.ico",
  activityPanel: {
    panelWidthSizeExpanded: 400,
  },
};
